import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BetRequest } from '../pages/bets/types/betListTypes';

interface BetRequestState {
  betRequests: BetRequest[];
}

const initialState: BetRequestState = {
  betRequests: [],
};

export const betRequestsSlice = createSlice({
  name: 'betRequests',
  initialState,
  reducers: {
    setBetRequests: (
      state: BetRequestState,
      action: PayloadAction<BetRequest[]>,
    ) => {
      state.betRequests = action.payload;
    },
    addBetRequest: (
      state: BetRequestState,
      action: PayloadAction<BetRequest>,
    ) => {
      state.betRequests = [action.payload, ...state.betRequests];
    },
    removeBetRequest: (
      state: BetRequestState,
      action: PayloadAction<{
            Id: number
        }>,
    ) => {
      const newRequests = state.betRequests.filter((br) => br.Id !== action.payload.Id);
      state.betRequests = newRequests;
    },
  },
});

export const { setBetRequests, addBetRequest, removeBetRequest } = betRequestsSlice.actions;

export default betRequestsSlice.reducer;
